export default {"src":"/pro/_next/static/media/mon.050fca78.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};